import enJson from './en.json';
import frJson from './fr.json';
import frCaJson from './fr-ca.json';
import pseudoJson from './pseudo.json';
import deJson from './de.json';
import esLaJson from './es-la.json';
import nlJson from './nl.json';
import itJson from './it.json';
import trJson from './tr.json';

import arJson from './ar.json';
import esCoJson from './es-CO.json';
import esEsJson from './es-ES.json';
import esMxJson from './es-MX.json';
import idJson from './id.json';
import jaJson from './ja.json';
import koJson from './ko.json';
import plJson from './pl.json';
import ptBrJson from './pt-BR.json';
import ruJson from './ru.json';
import zhHansJson from './zh-Hans.json';
import zhHantJson from './zh-Hant.json';



/* eslint-disable quote-props */
export default {
  translations: {
    'en': enJson,
    'en-us': enJson,
    'fr': frJson,
    'fr-fr': frJson,
    'fr-ca': frCaJson,
    'ts': pseudoJson,
    'de': deJson,
    'es-la': esLaJson,
    'nl': nlJson,
    'it': itJson,
    'tr': trJson,

    'ar': arJson,
    'es-CO':esCoJson,
    'es-ES':esEsJson,
    'es-MX':esMxJson,
    'es-419': esMxJson,
    'id': idJson,
    'ja': jaJson,
    'ko': koJson,
    'pl': plJson,
    'pt-BR': ptBrJson,
    'ru': ruJson,
    'zh': zhHansJson,
    'zh-Hans': zhHansJson,
    'zh-Hant': zhHantJson
  }
};



//////////////////
// WEBPACK FOOTER
// ./translations/index.js
// module id = null
// module chunks = 